import { Component } from '@angular/core';
import { BasePluginMenuComponent } from './base.menu';

@Component({
    templateUrl: './base.menu.html',
    standalone: false
})
export class PeopleMenuComponent extends BasePluginMenuComponent {}
